<template>
  <section>
    <div class="flex">
      <div
        class="viewer_container 0"
        id="3d"
        :style="{ display: `${is3d}` }"
      ></div>
      <div
        class="viewer_container 1"
        id="2d"
        :style="{ display: `${is2d}` }"
      ></div>
      <div
        class="viewer_container 2"
        id="2d_view"
        :style="{ display: `${is22d}` }"
      ></div>
    </div>

    <div>
      <div style="margin-left: 5px">
        <v-row>
          <v-col class="d-flex" cols="12" md="3" lg="2" sm="12">
            <v-select
              :items="views"
              v-model="setView"
              @change="getView"
              item-text="text"
              item-value="value"
              label="Model Views"
            ></v-select>
          </v-col>

          <v-col>
            <v-row>
              <div class="d-flex pa-4">
                <div class="d-flex flex-row ml-2 pt-2">
                  <strong> Pentalon Construction </strong>
                </div>
                <div class="d-flex flex-row pt-2 ml-4">
                  <strong> Project XYZ: </strong>
                </div>
                <div>
                  <p class="pt-2 ml-1">404 W 400 S Salt Lake City, 84101</p>
                </div>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div>
        <v-row>
          <div style="float: right" cols="12" md="3" lg="2" sm="12">
            <div class="d-flex justify-end mt-1 float-right">
              <div class="d-flex justify-end">
                Status:
                <v-chip
                  class="ml-2 mr-2"
                  color="green"
                  small
                  text-color="white"
                >
                  New
                </v-chip>
              </div>
              <div style="margin-right: 20px">
                <v-badge color="blue" style="margin-right: 10px">
                  <span slot="badge">3</span>
                  <v-icon medium color="yellow darken-2">
                    mdi-alert-outline
                  </v-icon>
                </v-badge>
                Issues
                <v-badge color="blue">
                  <span slot="badge">2</span>
                  <v-icon medium color="blue darken-2">
                    mdi-message-text
                  </v-icon>
                </v-badge>
              </div>
              <v-btn class="mr-2" small color="grey lighten-2">Export</v-btn>
              <v-btn
                small
                color="orange"
                to="/dealer/bid"
                style="margin-right: 5px"
              >
                Bid</v-btn
              >
            </div>
          </div>
          
           <ag-grid-vue
                 style="height: 500px; width: 100%"
            class="ag-theme-alpine"
            id="myGrid"
            ref="mygrid"
                :columnDefs="columnDefs"
                @grid-ready="onGridReady"
                :defaultColDef="defaultColDef"
                :masterDetail="true"
                :detailCellRendererParams="detailCellRendererParams"
                :rowData="detailList"
                :rowHeight=120
                 @rowClicked="autoSizeAll"
                ></ag-grid-vue>
        </v-row>
      </div>
    </div>
  </section>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import MessageIcon from "../../components/projectIcons.vue";
import dealerIcons from "../../components/dealerIcons.vue";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import {
  createViewer,
  viewer_3d,
} from "../../store/viewer_man";
export default {
  components: {
    AgGridVue,
    MessageIcon,
    dealerIcons
  },
  mounted() {
    createViewer({
      URN:
        "urn:" +
        "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cnVzaGFiaGF0ZW1haWxkb3Rjb20tcHJval9vbmVfMjRfanVuXzIwMjEtc2NoX29uZV8yNF9qdW5fMjAyMS9EZW1vX01vZGVsX0phbjIwMjFfMS5ydnQ",
      // windowElement: document.getElementById("3d"),
      windowElement_3d: document.getElementById("3d"),
      windowElement_2d: document.getElementById("2d"),
      windowElement_2d_building: document.getElementById("2d_view"),
      items: [],
    });
  },

  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: { flex: 1 },
      detailCellRendererParams: null,
      getRowHeight: null,
      autoGroupColumnDef: null,
      searchText: "",
      all: false,
      sentrfq: false,
      recieved: false,
      pending: false,
      dialog: false,
      columnDefs: [
        {
          headerName: "Window",
          width: 200, wrapText: true,
          field: "window",
          cellRenderer: 'agGroupCellRenderer'
        },
        {
          headerName: "location",
          minWidth: 80,
          field: "location",
        },
        {
          headerName: "Description",
          width: 300, wrapText: true,
          field: "descriptions",
        },
      
        // { headerName: "Type", minWidth: 80, field: "type" },
        { headerName: "RO", minWidth: 80, field: "ro", filter: true },
        { headerName: "Size", minWidth: 80, field: "size" },
        // { headerName: "Color", minWidth: 80, field: "color" },
        {
          headerName: "Performance",
          width: 350, wrapText: true,
          field: "performance",
          filter: true,
        },
        { headerName: "Test Report", minWidth: 80, field: "testReport" },
        {
          headerName: "Actions",
          minWidth: 80,
          cellRendererFramework: "dealerIcons",
        },
      ],
      detailList: [
        {
          window: "Artisan Casement, Fixed, 35.5 x 41.5",
          location: "18",
          family: "Studio",
          descriptions:
            "Black/White,1st glass ,LowE 366,3/16 over 3/16 super spacer",
          type: "Direct Set",
          ro: "18 * 15",
          size: "25 * 15",
          color: "white over white",
          performance:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR: 30,Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          details:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR:30 Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          testReport: "310-3235",
          details: [
            { Location: "18", Level: 10 },
            { Location: "18", Level: 10 },
          ],
        },
        {
          window: "Artisan Casement, Fixed, 35.5 x 41.5",
          location: "28",
          family: "Studio",
          descriptions:
            "Black/White,1st glass ,LowE 366,3/16 over 3/16 super spacer",
          type: "Direct Set",
          ro: "18 * 15",
          size: "25 * 15",
          color: "white over white",
          performance:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR: 30,Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          details:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR:30 Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          testReport: "310-3235",
          id: 1,
           details: [
            { Location: "18", Level: 10 },
            { Location: "18", Level: 10 },
          ],
        },
        {
          window: "Artisan Casement, Fixed, 35.5 x 41.5",
          location: "27",
          family: "Studio",
          descriptions:
            "Black/White,1st glass ,LowE 366,3/16 over 3/16 super spacer",
          type: "Direct Set",
          ro: "18 * 15",
          size: "25 * 15",
          color: "white over white",
          performance:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR: 30,Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          details:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR:30 Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          testReport: "310-3235",
          id: 2,
           details: [
            { Location: "18", Level: 10 },
            { Location: "18", Level: 10 },
          ],
        },
        {
          window: "Artisan Casement, Fixed, 35.5 x 41.5",
          location: "26",
          family: "Studio",
          descriptions:
            "Black/White,1st glass ,LowE 366,3/16 over 3/16 super spacer",
          type: "Direct Set",
          ro: "18 * 15",
          size: "25 * 15",
          color: "white over white",
          performance:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR: 30,Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          details:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR:30 Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          testReport: "310-3235",
          id: 3,
          details: [
            { Location: "18", Level: 10 },
            { Location: "18", Level: 10 },
          ],
        },
        {
          window: "Artisan Casement, Fixed, 35.5 x 41.5",
          location: "25",
          family: "Studio",
          descriptions:
            "Black/White,1st glass ,LowE 366,3/16 over 3/16 super spacer",
          type: "Direct Set",
          ro: "18 * 15",
          size: "25 * 15",
          color: "white over white",
          performance:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR: 30,Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          details:
            "U-Value: 0.32 SHGC: 0.31 VT: 0.57 CR: 56  STC: 30 OITC: 24 EWR:30 Structural: LC-PG25 Air: 0.05 Water: 5.25 3006",
          testReport: "310-3235",
          id: 3,
          details: [
            { Location: "18", Level: 10 },
            { Location: "18", Level: 10 },
          ],
        },
        
      ],
      is3d: "block",
      is2d: "none",
      is22d: "none",
      views: [
        { text: "Building View", value: "3d view" },
        { text: "Floor Plan", value: "2d geometry" },
        { text: "Elevation View", value: "2d view" },
      ],
      setView: "3d view",
    };
  },
  methods: {
    onGridReady(params) {

      this.gridApiTest = params.api;
      this.columnApi = params.columnApi;
      this.gridColumnApi = params.columnApi;

      // setTimeout(() => {
      //      this.autoSizeAll();
      //   }, 2000);
    },
    onFirstDataRendered(params) {
      setTimeout(function () {
        params.api.getDisplayedRowAtIndex(1).setExpanded(true);
      }, 0);
    },
    autoSizeAll() {
      // const allColumnIds = [];
      // if (this.gridColumnApi) {
      //   this.gridColumnApi.getAllDisplayedColumns().forEach((column) => {
      //     allColumnIds.push(column.colId);
      //   });
      //   this.gridColumnApi.autoSizeColumns(allColumnIds);
      // }

      let strId = 362754;
      strId = "[" + strId + "]";
      viewer_3d.search(strId, function (params) {
        viewer_3d.select(params, "Autodesk.Viewing.SelectionMode.REGULAR");
        viewer_3d.fitToView(params);
        viewer_3d.isolate(params);
      });
    },
    getView(value) {
      if (value == "3d view") {
        this.is3d = "block";
        this.is2d = "none";
        this.is22d = "none";

        // this.URN=version.URN;
        createViewer({
          URN:
            "urn:" +
            "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cnVzaGFiaGF0ZW1haWxkb3Rjb20tcHJval9vbmVfMjRfanVuXzIwMjEtc2NoX29uZV8yNF9qdW5fMjAyMS9EZW1vX01vZGVsX0phbjIwMjFfMS5ydnQ",
          // windowElement: document.getElementById("3d"),
          windowElement_3d: document.getElementById("3d"),
          windowElement_2d: document.getElementById("2d"),
          windowElement_2d_building: document.getElementById("2d_view"),
          items: [],
        });
      }
      if (value == "2d geometry") {
        this.is3d = "none";
        this.is2d = "block";
        this.is22d = "none";

        createViewer({
          URN:
            "urn:" +
            "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cnVzaGFiaGF0ZW1haWxkb3Rjb20tcHJval9vbmVfMjRfanVuXzIwMjEtc2NoX29uZV8yNF9qdW5fMjAyMS9EZW1vX01vZGVsX0phbjIwMjFfMS5ydnQ",
          // windowElement: document.getElementById("3d"),
          windowElement_3d: document.getElementById("3d"),
          windowElement_2d: document.getElementById("2d"),
          windowElement_2d_building: document.getElementById("2d_view"),
          items: [],
        });
      }
      if (value == "2d view") {
        this.is3d = "none";
        this.is2d = "none";
        this.is22d = "block";

        createViewer({
          URN:
            "urn:" +
            "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cnVzaGFiaGF0ZW1haWxkb3Rjb20tcHJval9vbmVfMjRfanVuXzIwMjEtc2NoX29uZV8yNF9qdW5fMjAyMS9EZW1vX01vZGVsX0phbjIwMjFfMS5ydnQ",
          // windowElement: document.getElementById("3d"),
          windowElement_3d: document.getElementById("3d"),
          windowElement_2d: document.getElementById("2d"),
          windowElement_2d_building: document.getElementById("2d_view"),
          items: [],
        });
      }
    },
  },
  beforeMount() {
    this.gridOptions = {};
    this.defaultColDef = { resizable: true };
    this.autoGroupColumnDef = {
      headerName: "familyAndType",
      field: "familyAndType",
      minWidth: 250,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: { checkbox: true },
    };
    this.rowSelection = "multiple";
  },
  created() {
    this.detailCellRendererParams = {
      detailGridOptions: {
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        enableRangeSelection: true,
        pagination: true,
        paginationAutoPageSize: true,
        columnDefs: [
          { field: "Location" },
          {
            field: "Level",
            minWidth: 150,
          },
          {
          field: "Actions",
          minWidth: 80,
          cellRendererFramework: "dealerIcons",
        }
        ],
        defaultColDef: {
          sortable: true,
          flex: 1,
        },
      },
      getDetailRowData: (params) => {
        console.log("=======Detail Data", params);
        params.successCallback(params.data.details);
      },
    };
  },
};
</script>

<style scoped>
.v-tab--active {
  color: inherit;
  background-color: #222020 !important;
}

.flex {
  display: flex;
  height: 100%;
  flex-direction: row;
  width: 100%;
  background: rebeccapurple;
}
.viewer_container {
  position: relative;
  height: 450px;
  width: 100%;
}
.font-class-name {
  font-size: 0.9em;
}
</style>
